module.exports = __webpack_public_path__ + "img/Press_Release_KasPro_x_KirimAja.46bccfdc.jpeg";